import { useV2ListServiceConditionsForAccountQuery } from "@generated";

export interface ServiceCondition {
  id: string;
  name: string;
  content: string;
  position: number;
}

// The account's default Terms & Conditions, ordered by position.
export const useServiceConditions = () => {
  const { data, isLoading } = useV2ListServiceConditionsForAccountQuery({
    filter: { active: true },
    page: { size: 100 },
  });

  const conditions: ServiceCondition[] = (data?.data ?? [])
    .map((c) => ({
      id: String(c.id),
      name: c.attributes?.name ?? "",
      content: c.attributes?.content ?? "",
      position: c.attributes?.position ?? 0,
    }))
    .sort((a, b) => a.position - b.position);

  return { conditions, isLoading };
};

export default useServiceConditions;
